import { Button, Col, Modal, Row } from 'antd'
import styled from 'styled-components'
import { CloseOutlined, WarningOutlined, PlusOutlined } from '@ant-design/icons'

const ModalBody = styled.div`
  b {
    display: contents;
  }
`

const ModalError = ({ open, onCancel, text }) => {
  const getHtmlBtn = () => {
    if(text.indexOf('nạp quỹ') > 0){
      return <Button onClick={onCancel} icon={<PlusOutlined/>}>Nạp thêm ký quỹ</Button>
    }
    return <Button onClick={onCancel} icon={<CloseOutlined/>}>Thoát</Button>
  }
  return (
    <Modal
      title={
        <p style={{ fontSize: '20px', fontWeight: 700 }}>
          <WarningOutlined /> Thông báo
        </p>
      }
      open={open}
      footer={getHtmlBtn()}
      onCancel={onCancel}
      width={700}
      maskClosable={false}
    >
      <ModalBody>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <p>{text}</p>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default ModalError
